// extracted by mini-css-extract-plugin
module.exports = {"container":"container--PromoResolveError-components__1r5sE","message":"message--PromoResolveError-components__10Z1H"};